<div class="checkin-skeleton-controls">
  <ui-skeleton [uiActive]="true" [uiTitle]="false" [uiSectionHeight]="{ paragraph: 'h-lg' }" [uiParagraph]="{ rows: 1, width: '100%' }"></ui-skeleton>
</div>

<div class="checkin-skeleton-main">
  <div>
    <ui-card>
      <ui-skeleton [uiActive]="true" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-lg' }" [uiTitle]="{ width: '100%' }" [uiParagraph]="{ width: '100%' }"></ui-skeleton>
    </ui-card>
  </div>
  <div>
    <ui-card class="checkin-skeleton-panel">
      <div class="checkin-skeleton-panel-header">
        <ui-skeleton-element [uiActive]="true" uiType="avatar"></ui-skeleton-element>
        <ui-skeleton class="sp-mb-0" [uiActive]="true" [uiTitle]="false" [uiParagraph]="{ rows: 1, width: '20%' }"></ui-skeleton>
      </div>
      <div class="checkin-skeleton-panel-inner">
        <ui-skeleton [uiActive]="true" [uiTitle]="{ width: '20%' }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-sm' }" [uiParagraph]="false"></ui-skeleton>
        <div class="checkin-skeleton-mood">
          <ui-skeleton-element *ngFor="let i of [1, 2, 3]" [uiActive]="true" uiType="avatar"></ui-skeleton-element>
        </div>
        <ui-skeleton
          *ngFor="let i of ['20%', '15%', '30%', '15%']"
          [uiActive]="true"
          [uiTitle]="{ width: i }"
          [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-sm' }"
          [uiParagraph]="{ rows: 1, width: '100%' }"></ui-skeleton>
      </div>
    </ui-card>
    <ui-skeleton *ngFor="let i of [1, 2, 3, 4, 5]" [uiActive]="true" [uiSectionHeight]="{ title: 'h-lg', paragraph: 'h-md' }" [uiParagraph]="false"></ui-skeleton>
  </div>
</div>
